import { OrderBookOrder } from '../../../../stores/OrderBook/orderBook.types';

interface ResolveProductDetailsOrderIdsParams {
  shouldApplyAllOrders?: boolean;
  allOrders: OrderBookOrder[];
  selectedOrderId?: string;
}

export const resolveProductDetailsOrderIds = ({
  shouldApplyAllOrders,
  allOrders,
  selectedOrderId,
}: ResolveProductDetailsOrderIdsParams) => {
  if (shouldApplyAllOrders) {
    return allOrders.map((order: OrderBookOrder) => order.id);
  }

  return selectedOrderId ? [selectedOrderId] : [];
};
